export default __webpack_public_path__ + "static/media/Andrea Mercieca - Vice President.258bb5d6.jpg";